package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.DefaultAlpha
import androidx.compose.ui.graphics.FilterQuality
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import dev.icerock.moko.resources.ImageResource
import com.example.mystybag.common.extensions.AsyncImage
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.sharedmodels.SCImage

@Composable
fun ShimmerAsyncImage(
    modifier        : Modifier          = Modifier,
    link            : String?           = null,
    image           : SCImage?          = null,
    placeholder     : ImageResource?    = SRC.images.img_placeholder,
    errorImage      : ImageResource?    = null,
    alignment       : Alignment         = Alignment.Center,
    contentScale    : ContentScale      = ContentScale.Fit,
    alpha           : Float             = DefaultAlpha,
    colorFilter     : ColorFilter?      = null,
    filterQuality   : FilterQuality     = DrawScope.DefaultFilterQuality,
    shimmerShape    : Shape             = CircleShape,
    useOriginalSize : Boolean           = false,
    onLoadSuccess   : (() -> Unit)?     = null
) {
    val shimmerEnabled = remember(link) { mutableStateOf(false) }

    BoxWithConstraints(modifier = modifier) {

        val targetValue = with(LocalDensity.current) { maxWidth.toPx() } * 1.5f

        AsyncImage(
            modifier            = Modifier.fillMaxSize(),
            link                = link,
            image               = image,
            placeholder         = placeholder,
            error               = errorImage,
            onLoading           = { shimmerEnabled.value = true },
            onError             = { shimmerEnabled.value = false },
            onSuccess           = {
                shimmerEnabled.value = false
                onLoadSuccess?.invoke()
            },
            onSuccessSimple     = { shimmerEnabled.value = false; onLoadSuccess?.invoke() },
            onErrorSimple       = { shimmerEnabled.value = false },
            alignment           = alignment,
            contentScale        = contentScale,
            alpha               = alpha,
            colorFilter         = colorFilter,
            filterQuality       = filterQuality,
            useOriginalSize     = useOriginalSize
        )

        Box(modifier = Modifier
            .fillMaxSize()
            .background(
                brush = ShimmerBrush(shimmerEnabled.value, targetValue),
                shape = shimmerShape
            )
        )
    }
}

/*@Preview
@Composable
fun ShimmerAsyncImagePreview() {
    Row(modifier = Modifier
        .fillMaxWidth()
        .padding(p2XS)
    ) {
        ShimmerAsyncImage(
            modifier        = Modifier
                .padding(p6XS)
                .clip(CircleShape)
                .size(pXL),
            image           = SRC.images.account_icon_001,
            loadingImage    = painterResource(SR.images.default_contact),
            errorImage      = painterResource(SR.images.default_contact)
        )
        Texts.Body2(text = "This is the shimmer image on the left.")
    }
}*/